import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container } from 'react-bootstrap'
import { LoadingComponent } from 'recupero-comunes'
import FiltroPanelDirecto from './filtro-panel'
import ResumenGeneral from './resumen-general'
import {
    obtenerResumenDirecto,
    obtenerMesesDirecto,
    obtenerProveedoresDirecto,
    obtenerKpisGlobalesDirecto,
    setFiltrosDirecto
} from '../../store/actions/dashboard-directo-action'
import { buildQueryDirecto } from '../../common/dashboard-utils'

const DashboardDirecto = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const filtros = useSelector((state) => state.dashboardDirectoReducer.filtros)

    const cargarDatos = () => {
        setLoading(true)
        dispatch(obtenerResumenDirecto(buildQueryDirecto(filtros))).finally(() => setLoading(false))
    }

    useEffect(() => {
        dispatch(obtenerProveedoresDirecto())
        dispatch(obtenerKpisGlobalesDirecto())

        // El filtro por defecto es el mes más reciente CON casos, no el mes en curso: al inicio
        // de un mes sin movimiento el tablero abriría en cero y el combo quedaría en blanco,
        // porque meses-disponibles solo devuelve períodos que tienen datos.
        setLoading(true)
        dispatch(obtenerMesesDirecto())
            .then((accion) => accion?.payload || [])
            .catch(() => [])
            .then((meses) => {
                const mesInicial = meses.length ? meses[meses.length - 1].valor : ''
                dispatch(setFiltrosDirecto({ mes: mesInicial }))
                return dispatch(obtenerResumenDirecto(buildQueryDirecto({ mes: mesInicial })))
            })
            .catch(() => {})
            .finally(() => setLoading(false))
    }, [dispatch])

    return (
        <div>
            <LoadingComponent show={loading} />
            <Container fluid className='py-3'>
                <Card>
                    <Card.Header as='h6' className='text-center' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        Tablero de Control — Recupero Directo
                    </Card.Header>
                    <Card.Body>
                        <FiltroPanelDirecto onBuscar={cargarDatos} />
                        {!loading && <ResumenGeneral />}
                    </Card.Body>
                </Card>
            </Container>
        </div>
    )
}

export default DashboardDirecto
